import './Footer.scss';
import {Stack, Container, Row, Col} from 'react-bootstrap';
import { TwitterX, Facebook, Instagram, Linkedin } from 'react-bootstrap-icons';

function Footer() {
  return (
    <Stack id="footer" gap={6} className="footer">
      <Container>
        <Row className="row gy-4 align-items-start">
          <Col sm md="9" lg="6">
            <h5 className="fw-semibold mb-3">Cube Tech Studio</h5>
            <p className="mb-3">Gurukrupa building, 1st floor, parvti Paytha , Golverkar guruji path, Nagpure chowk, Pune 411 009</p>
            <p className="mb-1"><strong>Phone :</strong> <a href="tel:+919270323478">+91 92703 23478</a></p>
            <p className="mb-1"><strong>Email :</strong> <a href="mailto:cubetechstudio@gmail.com">cubetechstudio@gmail.com</a>, 
            <br/>&nbsp; <a href="mailto:info@cubetechstudio.com" className='ms-5'>info@cubetechstudio.com</a></p>

            <div className="social-links d-flex mt-3">
              <a href="https://x.com/cubetechstudio" target="_blank"><TwitterX /></a>
              <a href="https://www.facebook.com/cubetechstudio" target="_blank"><Facebook/></a>
              <a href="https://www.instagram.com/cubetechstudio/" target="_blank"><Instagram /></a>
              <a href="https://www.linkedin.com/in/cubetechstudio-india-266758363/" target="_blank"><Linkedin /></a>
            </div>
          </Col>
          {/* <Col lg="3">
            <h5 className="fw-semibold mb-3">Useful Links</h5>
            <div className="d-flex flex-column">
              <a href="#" className="mb-1">Home</a>
              <a href="#about" className="mb-1">About</a>
              <a href="#services" className="mb-1">Services</a>
              <a href="#clients" className="mb-1">Clients</a>
              <a href="#work" className="mb-1">Work</a>
              <a href="career.html" className="">Career</a>
            </div>
          </Col>           */}
          <Col sm lg="6">
            <h5 className="fw-semibold mb-3">Location</h5>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.708116576127!2d73.8512892!3d18.4968759!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c1b9d46a2dff%3A0xa6133f57ddecad85!2sTvs%20Showroom%20Parvati!5e0!3m2!1sen!2sin!4v1787052903943!5m2!1sen!2sin" width="100%" height="190" loading="lazy" className='map'></iframe>
          </Col>
        </Row>
      </Container>
      <div className="text-center mt-4 border-top pt-3">
          <p className="mb-0">© 2026 Cubetech Studio. All rights reserved.</p>
      </div>
    </Stack>
  );
}

export default Footer;